import * as React from 'react';
import clsx from 'clsx';

export interface AuthLinkProps {
  text: string;
  actionText: string;
  onClick: () => void;
  disabled?: boolean;
  opacity?: boolean;
  variant?: 'light' | 'dark';
}

/** Inline text with a bold action link. White on mobile, dark on fold+. */
export const AuthLink: React.FC<AuthLinkProps> = ({
  text,
  actionText,
  onClick,
  disabled,
  opacity = false,
}) => (
  <p className={clsx('font-sans text-16 font-medium leading-21', 'text-white fold:text-gray-600')}>
    <span className={clsx(opacity && 'opacity-70')}>{text} </span>
    <button
      type='button'
      onClick={onClick}
      className={clsx(
        'font-bold underline decoration-solid transition-colors',
        'text-auth-link hover:text-white fold:text-brand-600 fold:hover:text-brand-800'
      )}
      disabled={disabled}
    >
      {actionText}
    </button>
  </p>
);

export default AuthLink;
